<template>
    <div class="warp">
      <!-- 面包屑 -->
      <!-- <breadcrumb :back="false" :crubList="[{ name: '系统配置' }, { name: '成功案例配置' }]" :title="'成功案例配置'"/> -->
      <el-tabs v-model="tab" @tab-click="changeTab" class="super_tab">
              <el-tab-pane label="需求发布" name="0"></el-tab-pane>
              <el-tab-pane label="成功案例" name="1"></el-tab-pane>
            </el-tabs>
      <div ref="condition">
      <el-button
        class="addbtns"
        type="primary"
        size="small"
        @click="addbtn"
        v-if="
          authorities.indexOf('sys:permission:background:hotCase:add') != -1
        "
        >添加案例</el-button>
        </div>
      <!-- 表格 -->
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        fit
      :height="bHeight"
      :header-cell-style="headerStyle"
      v-loading="loading"
                element-loading-text="请求中......"
      style="width:100%;"
      >
        <el-table-column
          prop="content"
          show-overflow-tooltip
          
          label="成功案例"
          width="600px"
        >
        </el-table-column>
        <el-table-column prop="type" show-overflow-tooltip label="数据类型">
          <template slot-scope="{row}">
            {{row.type === 1?'融资动态':row.type === 0?'需求发布':''}}
          </template>
        </el-table-column>
        <el-table-column
          prop="referee"
          show-overflow-tooltip
          
          label="添加人"
        >
        </el-table-column>
        <el-table-column
          prop="refereeTime"
          show-overflow-tooltip
          
          label="添加时间"
        >
        </el-table-column>
        
        <el-table-column
          v-if="
            authorities.indexOf('sys:permission:background:hotCase:edit') !=
              -1 ||
            authorities.indexOf('sys:permission:background:hotCase:del') != -1
          "
          label="操作"
          
          width="300px"
        >
          <template slot-scope="scope">
            <el-button
              size="small" type="primary" class="super" plain
              @click="editoer(scope.row)"
              v-if="
                authorities.indexOf('sys:permission:background:hotCase:edit') !=
                -1
              "
              >编辑
            </el-button>
            <el-button
              size="small" type="danger" class="super" plain
              v-if="
                authorities.indexOf('sys:permission:background:hotCase:del') !=
                -1
              "
              @click="deleteDell(scope.row.id)"
              >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" ref="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="sendInfoOne.currentPage"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="sendInfoOne.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize"
        >
        </el-pagination>
      </div>
      <!-- 添加热点 -->
      <el-dialog
        title="添加案例"
        :visible.sync="dialogAdd"
        :before-close="cancel"
        :close-on-click-modal="false"
        width="400"
      >
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="案例内容" prop="content">
            <el-input v-model="ruleForm.content"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="resetForm('ruleForm')">取消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')"
              >确认</el-button
            >
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
</template>
<script>
// import breadcrumb from "../../components/breadcrumb";
export default {
  components: {
    // breadcrumb,
  },
  data() {
    return {
      tab:'0',
      loading:false,
      bHeight: void 0,
      authorities: JSON.parse(window.localStorage.getItem("authorities")),
      sendInfoOne: {
        type: 0, // 类型：0=需求发布，1=成功案例
        direction: void 0, // 排序排序方式
        property: void 0,
        currentPage: 1, //页码
        pageSize: 10, //条数
      }, //检索提交数据
      tableData: [], //表格数据
      totalPage: null, //总页码
      dialogAdd: false,
      classifyList: [], //分类
      ruleForm: {
        content: null,
      },
      totalSize: 0,
      edit: false, //是否编辑
      newsDataSelect: [],
      rules: {
        content: [
          { required: true, message: "请输入案例内容", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    errors() {
      return this.$vuerify.$errors; // 错误信息会在 $vuerify.$errors 内体现
    },
  },
  
  methods: {
    changeTab(tab){
      this.tab = tab.name
      this.$router.replace({ path: this.$router.path, query: { stype: tab.name } })
      const  param = {
        type: Number(this.tab), // 类型：0=需求发布，1=成功案例
        direction: void 0, // 排序排序方式
        property: void 0,
        currentPage: 1, //页码
        pageSize: 10, //条数
      }
      this.sendInfoOne = Object.assign(this.sendInfoOne,param)
      this.getData()
    },
    doLayout() {
            this.$nextTick(() => {
              if (this.$refs.multipleTable && this.$refs.multipleTable.doLayout) {
                this.$refs.multipleTable.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
    chooseItem(data) {
      console.log(data);
      this.ruleForm = Object.assign(this.ruleForm, data);
    },
    // 添加按钮
    addbtn() {
      this.edit = false;
      this.getSelect();
    },
    submitForm(formName) {
      console.log(this.ruleForm);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.edit) {
            this.$axioscBody
              .post(`/backstage/hotCase/add?content=${this.ruleForm.content}`)
              .then((r) => {
                if (r.code == 200) {
                  this.$message({
                    type: "success",
                    message: r.msg,
                  });
                  this.getData();
                  this.resetForm(formName);
                } else {
                  this.$alert(r.msg);
                }
              });
          } else {
            this.$axioscBody
              .put("/backstage/hotCase/edit", this.ruleForm)
              .then((r) => {
                if (r.code == 200) {
                  this.$message({
                    type: "success",
                    message: r.msg,
                  });
                  this.getData();

                  this.resetForm(formName);
                } else {
                  this.$alert(r.msg);
                }
              });
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.ruleForm = {
        content: null,
      };
      this.dialogAdd = false;
      this.$refs[formName].resetField();
    },
    // 编辑回显
    editoer(row) {
      // this.ruleForm = {
      //   content: row.content,
      //   id: row.id,
      // };
      // this.edit = true;
      // this.dialogAdd = true;      
      
      this.$router.push({path: `/systemLayout/SuccessfulCases/edit/${row.id}`, query: {index: '/systemLayout/SuccessfulCases',content:row.content},param:{id:row.id,content:row.content}})
    },
    deleteDell(id) {
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axiosc
            .delete("/backstage/hotCase/del", { params: { id: id } })
            .then((r) => {
              if (r.code == 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                if (this.tableData.legnth == 1) {
                  this.sendInfoOne.currentPage = 1;
                }
                this.getData();
              } else {
                this.$alert(r.msg);
              }
            });
        })
        .catch(() => {});
    },
    //切换每页显示条数
    handleSizeChange(val) {
      this.sendInfoOne.pageSize = val;
      this.getData();
    },
    //切换页码
    handleCurrentChange(val) {
      this.sendInfoOne.currentPage = val;
      this.getData();
    },
    //取消按钮
    cancel: function (type) {
      this.dialogAdd = false;
    },
    getSelect() {
      // this.$axiosc.get("backstage/hotProduct/select", {}).then((r) => {
      //   if (r.code == 200) {
      //     this.newsDataSelect = r.data;
      //   } else {
      //     this.$alert(r.msg);
      //   }
      // });
      // this.ruleForm = {
      //   content: null,
      // };
      // this.dialogAdd = true;
      this.$router.push({path: `/systemLayout/SuccessfulCases/add`, query: {index: '/systemLayout/SuccessfulCases'}})
    },
    //获取数据
    getData() {
      this.loading = true
      this.$axiosc.get("/backstage/hotCase/list", { params: this.sendInfoOne })
        .then((r) => {
          this.loading = false
          if (r.code == 200) {
            this.tableData = r.data.content;
            this.totalSize = r.data.totalElements;
          } else {
            this.$alert(r.msg);
          }
        }).catch(e=>{
          this.loading = false
        })
    },
  },
  mounted() {
    const that = this
    const {stype} = this.$route.query
    if(stype){
      this.tab = stype
      this.sendInfoOne.type = Number(stype)
    }
    that.getData();
    let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 70
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 70
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
  },
  // watch:{
  //   '$route.query.stype': {
  //     handler(newVal,oldVal){
  //       //判断newVal有没有值监听路由变化
  //       debugger
  //        this.tab = newVal
  //   },
  //   deep: true
  //   }

  // },
};
</script>

<style scoped="scoped" lang="scss">
.forms {
  /deep/ .el-select {
    width: 300px;
  }
  .child {
    .remark {
      /deep/ .el-textarea__inner {
        min-height: 122px !important;
      }
    }
    .name {
      width: 123px;
    }
  }
}

.tabs {
  border: 0;
}

.addbtns {
  margin: 0px 0 10px;
}

/deep/ .el-dialog {
  width: 450px;
}
</style>
